/**
 * "Época de escrita" da API: contador que avança a cada POST/PUT/PATCH/DELETE que
 * passa pelo axios `api` (interceptor em `api.ts`), com sucesso ou falha — uma
 * escrita que falhou pode ter persistido parte do efeito.
 *
 * Os caches de leitura compartilhados (`src/utils/sharedLoad.ts`) entram com a
 * época na chave: qualquer escrita derruba o cache, sem depender de cada tela que
 * cria/edita/arquiva escala ou unidade lembrar de invalidar. O custo é um refetch
 * na próxima tela que pedir a lista — nunca dado velho.
 */
let writeEpoch = 0

const WRITE_METHODS = new Set(['post', 'put', 'patch', 'delete'])

export function noteApiWrite(method: string | undefined): void {
  if (method && WRITE_METHODS.has(method.toLowerCase())) writeEpoch += 1
}

export function getWriteEpoch(): number {
  return writeEpoch
}
